<template>
    <div class="row mb-3">
        <div class="col-sm-12 col-md-12">
            <ul class="warranty-submenu">
                <li>
                    <router-link :to="{name: 'SuperadminWarrantyReport'}">Warranties</router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminRepairReport'}">Repairs</router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminResellerCustomerPieChart'}">Depos</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'reportNav'
};
</script>
